import { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from "react-i18next";
import { showLoader, hideLoader } from '../../../store/common/slice';
import {getAllKnownVendors, getAllExpenseTypes, checkBankChargePermission} from '../../../store/expenses/actions';
import { useAccessToken } from "../../../common/hooks/useAccessToken";
import useBodyClass from "../../../common/hooks/useBodyClassName";
import Button from "../../../common/Button";
import SetExpenseBuildingImg from "../../../images/newDesign/set_expense_building.svg";
import check from "../../../images/newDesign/bllink_check.svg";
import NewSupplierPopUp from "../newSupplierPopUp";
import { WrapperStyled, SetExpenseWrapperStyled } from "./SetExpense.styled";
import AddExpenseModal from "./AddExpenseModal";
import {constants} from "../../../common/constants/constants";

const SetExpense = ({ match }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { buildingID } = match.params;
    const client = useAccessToken();
    useBodyClass('report');
    const titleData = useSelector(state => state.buildings.titleData);
    const building = useSelector(state => state.buildings.currentBuildingData);

    const vendors = useSelector(state => state.expenses.allKnownVendors);
    const expenseTypes = useSelector(state => state.expenses.expenseTypes);
    const hasBankChargePermission = useSelector(state => state.expenses.hasBankChargePermission);

    useEffect(async () => {
        if (!client) return;

        dispatch(showLoader());

        if (!expenseTypes.length) await dispatch(getAllExpenseTypes());
        if (!vendors.length) await dispatch(getAllKnownVendors(buildingID));
        if (hasBankChargePermission == null) await dispatch(checkBankChargePermission(buildingID));

        dispatch(hideLoader());
    }, [client]);

    const [showAddExpenseModal, setShowAddExpenseModal] = useState(false);
    const [showVendorPopup, setShowVendorPopup] = useState(false);

    const openAddExpenseModal = () => setShowAddExpenseModal(true);
    const hideAddExpenseModal = () => setShowAddExpenseModal(false);

    const openVendorPopup = () => {
        setShowAddExpenseModal(false);
        setShowVendorPopup(true);
    };

    const hideVendorPopup = () => {
        setShowVendorPopup(false);
        setShowAddExpenseModal(true);
    };

    const onVendorAdded = async () => {
        dispatch(showLoader());
        await dispatch(getAllKnownVendors(buildingID));
        dispatch(hideLoader());
        hideVendorPopup(false);
    };

    return (
        <WrapperStyled>
            <h1 className='page-title text-only'>
                {t('expenses.set_expenses.title_add_expense')}
                {titleData.translationKey && (
                    <span className='building-address'>{t('payments.' + titleData.translationKey, titleData)}</span>
                )}
            </h1>
            <SetExpenseWrapperStyled className="ensure-height">
                <div className="set-expense-info">
                    <div className="set-expense-title">{t('expenses.set_expenses.manage_expenses')}</div>

                    <div className="building">
                        <img src={SetExpenseBuildingImg} alt="Building" />
                        <div className="set-expense-subtitle">{t('expenses.set_expenses.connect_bank_account')}</div>
                    </div>

                    <Button
                        type='button'
                        onClick={openAddExpenseModal}
                    >                 
                        {t('expenses.set_expenses.add_expense')}
                    </Button>
                </div>
                <div className="set-expense-text">
                    <div className="header">{t('expenses.set_expenses.online_interface')}</div>
                    <div className="subheader">{t('expenses.set_expenses.use_bllink_digital_payments')}</div>

                    <div className="list-item">
                        <img src={check} />
                        <div className="item-text">
                            <div className="item-header">{t('expenses.set_expenses.establish_expense')}</div>
                            <div className="item-plain-text">{t('expenses.set_expenses.for_payments')}</div>
                        </div>
                    </div>

                    <div className="list-item">
                        <img src={check} />
                        <div className="item-text">
                            <div className="item-header">{t('expenses.set_expenses.add_means_of_payment')}</div>
                            <div className="item-plain-text">{t('expenses.set_expenses.skip_saving')}</div>
                        </div>
                    </div>
                    
                    <div className="list-item">
                        <img src={check} />
                        <div className="item-text">
                            <div className="item-header">{t('expenses.set_expenses.payment_is_recorded')}</div>
                            <div className="item-plain-text">{t('expenses.set_expenses.enters_icome_balance')}</div>
                        </div>
                    </div>

                    {hasBankChargePermission !== null && !hasBankChargePermission && (
                        <div className="registration">
                            <h3 className="bllink-heading3">{t('expenses.register.title')}</h3>
                            <a className="bllink-text-tiny-bold" target="_blank" rel="noreferrer" href={`/building/${buildingID}/${constants.pages.bankChargeUrl}`}>{t('expenses.register.registerHere')}</a>
                        </div>
                    )}

                </div>

                <AddExpenseModal 
                    show={showAddExpenseModal}
                    onModalHide={hideAddExpenseModal}
                    buildingID={buildingID}
                    vendors={vendors}
                    expenseTypes={expenseTypes}
                    openVendorPopup={openVendorPopup}
                />

                <NewSupplierPopUp
                    show={showVendorPopup}
                    onModalHide={hideVendorPopup}
                    onVendorAdded={onVendorAdded}
                    building={building}
                    buildingID={buildingID}
                />
            </SetExpenseWrapperStyled>       
        </WrapperStyled>
    )
}

export default SetExpense;
